import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useCallbackPrompt } from "../../hooks/useCallbackPrompt";
import SFDialog from "../dialog";

const SFPrompt = ({
  hasChanges,
  open,
  setOpen,
  onConfirm,
  onOpen,
  onClose,
}) => {
  const { t } = useTranslation();
  const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(
    hasChanges,
    onOpen,
    onClose
  );

  const handleLeave = () => {
    if (onConfirm && open) {
      onConfirm();
    } else {
      confirmNavigation();
    }
  };

  const handleCancel = () => {
    if (setOpen && open) {
      setOpen(false);
    } else {
      cancelNavigation();
    }
  };

  return (
    <SFDialog
      variant="default"
      title={t("components.prompt.header")}
      message={t("components.prompt.unsavedChanges")}
      open={showPrompt || open}
      onClose={handleCancel}
      primaryButton
      primaryButtonProps={{
        label: t("components.prompt.leave"),
        onClick: handleLeave,
      }}
      secondaryButton
      secondaryButtonProps={{
        label: t("components.prompt.cancel"),
        onClick: handleCancel,
      }}
    />
  );
};

SFPrompt.defaultProps = {
  hasChanges: true,
  open: false,
  setOpen: null,
  onConfirm: null,
  onOpen: () => {},
  onClose: () => {},
};

SFPrompt.propTypes = {
  hasChanges: PropTypes.bool,
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  onConfirm: PropTypes.func,
  /**
   * Callback function to be called when the prompt is opened.
   */
  onOpen: PropTypes.func,
  /**
   * Callback function to be called when the prompt is closed.
   */
  onClose: PropTypes.func,
};

export default SFPrompt;
